module.exports = {"TXTCLI_Street_Address":{"id":"TXTCLI_Street_Address","defaultMessage":"Adresse","flags":["TRACK"],"track":"Street Address"}}